// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.
// frontend/src/components/mission-launch/shared/MissionCard.jsx

import React from 'react';

export default function MissionCard({
  eyebrow = '',
  title = '',
  description = '',
  children,
  action,
  className = '',
  tone = 'default',
}) {
  return (
    <section className={`mission-launch-card mission-launch-card-${tone} ${className}`.trim()}>
      <div className="mission-launch-card-glow" aria-hidden="true" />
      <div className="mission-launch-card-header">
        <div>
          {eyebrow ? <p className="mission-launch-eyebrow">{eyebrow}</p> : null}
          {title ? <h3>{title}</h3> : null}
          {description ? <p className="mission-launch-muted">{description}</p> : null}
        </div>
        {action ? <div className="mission-launch-card-action">{action}</div> : null}
      </div>
      {children ? <div className="mission-launch-card-body">{children}</div> : null}
    </section>
  );
}
